var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCross = function SvgIconCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.31.54.15.15a1.86 1.86 0 0 1 0 2.62L10.77 8l4.69 4.69a1.86 1.86 0 0 1 0 2.62l-.15.15a1.86 1.86 0 0 1-2.62 0L8 10.77l-4.69 4.69a1.86 1.86 0 0 1-2.62 0l-.15-.15a1.86 1.86 0 0 1 0-2.62L5.23 8 .54 3.31a1.86 1.86 0 0 1 0-2.62L.69.54a1.86 1.86 0 0 1 2.62 0L8 5.23 12.69.54a1.86 1.86 0 0 1 2.62 0"
  })));
};
export default SvgIconCross;